import { ControlParameter, SliderParameters } from '@models/claims';

export class SliderHelper {

  static getSliderParameters(controlParameters: ControlParameter[]): SliderParameters {
    let parameters = new SliderParameters();

    controlParameters?.forEach(cp => {
      switch (cp.key.toUpperCase()) {
        case 'MIN':
          parameters.min = parseInt(cp.value, 10);
          break;
        case 'MAX':
          parameters.max = parseInt(cp.value, 10);
          break;
        case 'STEP_SIZE':
          parameters.step = parseInt(cp.value, 10);
          break;
        case 'MIN_SELECTABLE':
          parameters.minSelectable = parseInt(cp.value, 10);
          break;
        case 'MAX_SELECTABLE':
          parameters.maxSelectable = parseInt(cp.value, 10);
          break;
        case 'MIN_TEXT':
          parameters.minText = cp.value;
          break;
        case 'MAX_TEXT':
          parameters.maxText = cp.value;
          break;
      }
    });

    if (parameters.minSelectable == null)
      parameters.minSelectable = parameters.min;

    if (parameters.maxSelectable == null)
      parameters.maxSelectable = parameters.max;

    return parameters;
  }

  static getDefaultValue(sliderParameters: SliderParameters): number {
    let value = (sliderParameters.min + sliderParameters.max) / 2;
    if (value < sliderParameters.minSelectable)
      return sliderParameters.minSelectable;

    if (value > sliderParameters.maxSelectable)
      return sliderParameters.maxSelectable;

    return value;
  }
}
